"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserDatasourceConfigRequest = exports.isUserDatasourceConfig = void 0;
const isUserDatasourceConfig = (cfg) => {
    return cfg !== null && 'stacked_tabs' in cfg && 'fields' in cfg;
};
exports.isUserDatasourceConfig = isUserDatasourceConfig;
const isUserDatasourceConfigRequest = (cfg) => {
    return 'stacked_tabs' in cfg && 'fields' in cfg;
};
exports.isUserDatasourceConfigRequest = isUserDatasourceConfigRequest;
